import React, { useRef, useEffect } from 'react';
import './VideoPG.scss';
import LogoTooltip from './LogoTooltip/LogoTooltip';
import Header from './common-header/Header';
import Player from '@vimeo/player';
import contents from './contents';
import RelatedContents from './RelatedContents/RelatedContents';
import arrow from './assets/arrow_nav.svg';

function VideoPG({ logoPlacement, mutedAutoPlay }) {
  const logoP = logoPlacement || contents.logoTooltip.logoPlacement;
  const videoRef = useRef();

  useEffect(() => {
    const autoP = mutedAutoPlay || contents.videoAutoPlay;
    const autoPlayOnLoad = () => {
      const player = new Player(videoRef.current);

      player
        .setMuted(true)
        .then(function () {
          player.enableTextTrack('en-US');
        })
        .then(function () {
          player.play();
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    if (autoP) {
      autoPlayOnLoad();
    }
  }, [mutedAutoPlay]);

  return (
    <main className="videoPG">
      <Header clientName={contents.header} />

      <div className={logoP === 'top' ? 'videoPG__logoContainer--top' : 'videoPG__logoContainer'}>
        <nav className="videoPG__nav" aria-label="Navigate to related content">
          <a href={contents.url} target="_blank" rel="sponsored" className="videoPG__nav__link">
            <img src={arrow} className="videoPG__nav__arrow videoPG__nav__arrow-left" alt="" />
            Return to Hub
          </a>
          <a
            href={contents.url2}
            target="_blank"
            rel="sponsored"
            className="videoPG__nav__link videoPG__nav__link-right"
          >
            next province
            <img src={arrow} className="videoPG__nav__arrow videoPG__nav__arrow-right" alt="" />
          </a>
        </nav>
        <a
          href={contents.url}
          target="_blank"
          rel="sponsored"
          className="videoPG__nav__link videoPG__nav__link-desktop"
        >
          <img src={arrow} className="videoPG__nav__arrow videoPG__nav__arrow-left" alt="" />
          Return to Hub
        </a>
        <div className="videoPG__logoContainer__logo">
          <LogoTooltip logoTooltipContents={contents.logoTooltip} />
        </div>
        <a
          href={contents.url2}
          target="_blank"
          rel="sponsored"
          className="videoPG__nav__link videoPG__nav__link-desktop videoPG__nav__link-right"
        >
          next province
          <img src={arrow} className="videoPG__nav__arrow videoPG__nav__arrow-right" alt="" />
        </a>
      </div>

      <div className="videoPG__video">
        <iframe
          src={contents.video}
          frameBorder="0"
          allow={
            mutedAutoPlay
              ? 'autoplay; fullscreen; picture-in-picture'
              : 'fullscreen; picture-in-picture'
          }
          className="videoPG__video__videoPlayer"
          title={contents.videoTitle}
          ref={videoRef}
          autoPlay="1"
          muted="1"
        ></iframe>
      </div>
      <div className="videoPG__copy">
        <h1 className="videoPG__copy--title">{contents.title}</h1>
        <p className="videoPG__copy--body">{contents.copy}</p>
        <div className="videoPG__buttons">
          <a href={contents.url} target="_blank" rel="sponsored">
            <button className="videoPG__cta__button" aria-label="Visit This Is Canada Hub Page">
              {contents.button}
            </button>
          </a>
          <a href={contents.url2} target="_blank" rel="sponsored">
            <button className="videoPG__cta__button">watch next video</button>
          </a>
        </div>
      </div>
      <RelatedContents />
    </main>
  );
}

export default VideoPG;
